import request from '../request'
import apis from '../apis'

export default {
    // 查询座位号列表
    findSeatListSer({ pageVO, params }) {
        return request.post(`${apis.FIND_SEAT_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, params)
    },
    // 查询嘉宾明细
    findGuestDetailByIdSer(params) {
        return request.get(`${apis.FIND_GUEST_DETAIL_BY_ID}/${params.id}`)
    },
    // 导出座位号列表
    exportSeatSer(params) {
        return request.post(apis.EXPORT_SEAT, params)
    },
    // 批量添加座位
    batchCreateSeatSer(params) {
        return request.post(apis.BATCH_SAVE_SEAT, params)
    },
    // 批量修改座位
    batchUpdateSeatSer(params) {
        return request.post(apis.BATCH_UPDATE_SEAT, params)
    },
    // 批量删除座位
    batchDeleteSeatSer(params) {
        return request.post(apis.BATCH_DELETE_SEAT, params)
    },
    // 批量删除作废座位
    batchDeleteVoidedSeatSer(params) {
        return request.post(apis.BATCH_DELETE_VOIDED_SEAT, params)
    },
    // 添加嘉宾
    createGuestSer(params) {
        return request.post(apis.CREATE_GUEST, params)
    },
    // 取消嘉宾
    cancelGuestSer(params) {
        return request.post(apis.GUEST_CANCEL, params)
    },
    // 导出嘉宾
    exportGuestSer(params) {
        return request.post(apis.EXPORT_GUEST, params)
    },
    // 修改嘉宾
    updateGuestSer(params) {
        return request.post(apis.UPDATE_GUEST, params)
    },
    // 查询嘉宾列表
    findGuestListSer({ pageVO, params }) {
        return request.post(`${apis.FIND_GUEST_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, params)
    },
    // 查询嘉宾座位列表
    findGuestSeatListSer({ pageVO, params }) {
        return request.post(`${apis.FIND_GUEST_SEAT_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, params)
    },
    // 查询隐私配置列表
    findPrivacyListSer({ pageVO, params }) {
        return request.post(`${apis.FIND_PRIVACY_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, params)
    },
    // 新增、修改隐私配置
    addOrUpdatePrivacySer(params) {
        return request.post(apis.ADD_UPDATE_PRIVACY, params)
    },
    // 隐私配置详情
    getPrivacyInfoSer(params) {
        return request.get(apis.GET_PRIVACY_INFO, { params });
    },
    // 批量删除隐私配置
    deletePrivacyListSer(params) {
        return request.post(apis.DEL_PRIVACY_LIST, params)
    },
    // 获取欧盟标识
    getEUFlageSer(params) {
        return request.get(apis.GET_EU_FLAG, { params });
    },
    // 审批配置
    updateApproveConfigSer(params) {
        return request.post(apis.UPDATE_APPROVE_CONFIG, params)
    },
    // 查询短信配置
    querySmsConfigSer(params) {
        return request.get(`${apis.QUERY_SMS_CONFIG}/${params.exhiId}`)
    },
    // 更新短信配置
    updateSmsConfigSer(params) {
        return request.put(apis.UPDATE_SMS_CONFIG, params)
    },
    // 保存短信配置
    saveSmsConfigSer(params) {
        return request.post(apis.SAVE_SMS_CONFIG, params)
    },
    // 获取审批人列表
    getApproversSer(params) {
        return request.get(apis.GET_APPROVERS, { params });
    },
    // 新增演讲嘉宾
    createSpeakerSer(params) {
        return request.post(apis.CREATE_SPEAKER, params)
    },
    // 修改演讲嘉宾
    updateSpeakerSer(params) {
        return request.post(apis.UPDATE_SPEAKER, params)
    },
    // 批量删除演讲嘉宾
    deleteSpeakerSer(params) {
        return request.post(apis.DELETE_SPEAKER, params)
    },
    // 分页查询演讲嘉宾
    getSpeakerListSer({ pageVO, params }) {
        return request.get(`${apis.GET_SPEAKER_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 转赠审批管理分页列表
    getSeatTransListSer({ pageVO, params }) {
        return request.get(`${apis.GET_SEAT_TRANS_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 批量通过审批
    batchPassSeatSer(params) {
        return request.post(apis.BATCH_PASS_SEAT_TRANS, params)
    },
    // 批量驳回审批
    batchRejectSeatSer(params) {
        return request.post(apis.BATCH_REJECT_SEAT_TRANS, params)
    },
    // 分页查询员工组别
    getEmpGroupListSer({ pageVO, params }) {
        return request.get(`${apis.GET_EMPGROUP_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 查询全部员工组别
    getEmpGroupListAllSer(params) {
        return request.get(apis.GET_EMPGROUP_ALL, { params });
    },
    // 批量新增员工组别
    batchCreateEmpGrouopSer(params) {
        return request.post(apis.BATCH_CREATE_EMPGROUP, params)
    },
    // 批量修改员工组别
    batchUpdateEmpGrouopSer(params) {
        return request.post(apis.BATCH_UPDATE_EMPGROUP, params)
    },
    // 批量删除员工组别
    batchDeleteEmpGrouopSer(params) {
        return request.post(apis.BATCH_DELETE_EMPGROUP, params)
    },
    // 导出员工组别
    exportEmpGrouopSer(params) {
        return request.get(apis.EXPORT_EMPGROUP, { params });
    },
    // 查询员工根据Id
    getEmpgroupByIdSer(params) {
        return request.get(apis.GET_EMPGROUP_BYID, { params });
    },
    // 分页查询员工报名
    getEmpListSer({ pageVO, params }) {
        return request.get(`${apis.GET_EMP_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 员工签到
    empSignSer(params) {
        return request.post(apis.EMP_SIGN, params)
    },
    // 新增员工报名
    createEmpSer(params) {
        return request.post(apis.CREATE_EMP, params)
    },
    // 修改员工报名
    updateEmpSer(params) {
        return request.post(apis.UPDATE_EMP, params)
    },
    // 批量取消员工报名
    batchCancelEmpSer(params) {
        return request.post(apis.BATCH_CANCEL_EMP, params)
    },
    // 批量删除 员工报名
    batchDeleteEmpSer(params) {
        return request.delete(apis.BATCH_DELETE_EMP, { data: params });
    },
    // 转让工作证
    transCardSer(params) {
        return request.post(apis.TRANS_WORK_CARD, params)
    },
    // 恢复座位号
    seatRecoverSer(params) {
        return request.put(apis.SEAT_RECOVER, params)
    },
    // 导出员工报名
    exportEmpSer(params) {
        return request.get(apis.EXPORT_EMP, { params });
    },
    downloadEmpImgsSer(params) {
        return request.get(apis.BATCH_DOWNLOAD_EMPIMG, { params });
    },
    // 上传员工头像
    uploadEmpSer({ formData, stparams }) {
        return request.post(`${apis.UPLOAD_EMP_HEADER}&attType=${stparams.attType}&thumbFlag=${stparams.thumbFlag}&checkFace=${stparams.checkFace}`, formData)
    },
    // 分页查询议程配置
    getActivityListSer({ pageVO, params }) {
        return request.get(`${apis.GET_ACTIVITY_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 批量添加议程配置
    batchAddActivitySer(params) {
        return request.post(apis.BATCH_ADD_ACTIVITY, params)
    },
    // 批量修改议程配置
    batchUpdateActivitySer(params) {
        return request.post(apis.BATCH_UPDATE_ACTIVITY, params)
    },
    // 批量删除议程配置
    batchDeleteActivitySer(params) {
        return request.post(apis.BATCH_DELETE_ACTIVITY, params)
    },
    // 发送图片邮件
    sendPictureEmailSer(params) {
        return request.post(apis.SEND_PICTURE_EMAIL, params)
    },
    // 批量删除议程配置
    importExcelSer({ formData, params }) {
        return request.post(`${apis.IMPORT_EXCEL}&excelType=${params.excelType}&exhiId=${params.exhiId}&language=${params.lang}`, formData)
    },
    // 导入任务查询
    findImportExcelByTaskIdSer(params) {
        return request.post(apis.FIND_IMPORT_EXCEL_BY_TASKID, params)
    },
    // 设置员工权限
    setEmpPerm(params) {
        return request.post(apis.EMP_PERM_SETTING, params)
    },
    // 发送员工参会消息
    sendAttendMsg(params) {
        return request.post(apis.SEND_EMP_ATTEND_MSG, params)
    },
    // 发送嘉宾参会消息
    sendGuestAttendMsg(params) {
        return request.post(apis.SEND_GUEST_ATTEND_MSG, params)
    },
    // 查询发送日志列表
    findMessageLogByPageSer({ pageVO, params }) {
        return request.post(`${apis.FIND_MESSAGE_LOG_BY_PAGE}/${pageVO.pageSize}/${pageVO.curPage}`, params)
    },
    // 代表列表
    getTaskList({ pageVO, params }) {
        return request.get(`${apis.EMP_TASK_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 批量审批
    batchApproveEmp(params) {
        return request.post(apis.BATCH_APPROVE_EMP, params)
    },
    batchReviewApprove(params) {
        return request.post(apis.BATCH_REVIEW_APPROVE, params)
    },
    // 审批详情
    getApproveDetail(params) {
        return request.get(apis.APPROVE_DETAIL, { params });
    },
    // 审批日志
    reviewTaskListSer(params) {
        return request.get(apis.REVIEW_TASK_LIST, { params });
    },
    // 全量员工权限
    getEmpPermListAll(params) {
        return request.get(apis.BATCH_EMP_PERM, { params });
    },
    // 员工权限配置列表
    getEmpPermList({ pageVO, params }) {
        return request.get(`${apis.GET_EMPPERM_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 员工权限配置 批量新增
    addEmpPerms(params) {
        return request.post(apis.BATCH_EMP_PERM, params)
    },
    // 员工权限配置 批量修改
    updateEmpPerms(params) {
        return request.put(apis.BATCH_EMP_PERM, params)
    },
    // 员工权限配置 批量删除
    delEmpPerms(params) {
        return request.delete(apis.BATCH_EMP_PERM, { data: params });
    },
    // 区域列表
    getRegionListByPage({ pageVO, params }) {
        return request.get(`${apis.GET_REGION_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 批量新增区域
    batchAddRegion(params) {
        return request.post(apis.BATCH_HANDLE_REGION, params)
    },
    // 批量修改区域
    batchUpdateRegion(params) {
        return request.put(apis.BATCH_HANDLE_REGION, params)
    },
    // 批量删除区域
    batchDelRegion(params) {
        return request.delete(apis.BATCH_HANDLE_REGION, { data: params });
    },
    // 全量票众
    getClassListByAll(params) {
        return request.get(apis.BATCH_HANDLE_CLASS, { params });
    },
    // 票众列表
    getClassListByPage({ pageVO, params }) {
        return request.get(`${apis.GET_CLASS_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 批量新增票众
    batchAddClass(params) {
        return request.post(apis.BATCH_HANDLE_CLASS, params)
    },
    // 批量修改票众
    batchUpdateClass(params) {
        return request.put(apis.BATCH_HANDLE_CLASS, params)
    },
    // 批量删除票众
    batchDelClass(params) {
        return request.delete(apis.BATCH_HANDLE_CLASS, { data: params });
    },
    // 导出票众分类
    exportAudienceSer(params) {
        return request.get(apis.EXPORT_AUDIENCE_CLASS, { params });
    },
    // 导出区域
    exportRegionSer(params) {
        return request.get(apis.EXPORT_REGION, { params });
    },
    // 导出权限
    exportPermSer(params) {
        return request.get(apis.EXPORT_PERMISSION, { params });
    },
    // 导出权限
    registStatisticsSer(params) {
        return request.get(apis.REGIST_STATISTICS, { params });
    },
    // 是否显示电子票
    showTicketSer(params) {
        return request.get(apis.SHOW_TICKET, { params });
    },
    // 统计查询
    staticGuestAudienceCountSer(params) {
        return request.get(apis.GUEST_STATIC_AUDIENCE_COUNT, { params });
    },
    // 导出统计
    exportStaticGuestCountSer(params) {
        return request.get(apis.GUEST_STATIC_EXPORT_COUNT, { params });
    },
    // 黑名单清单列表
    getBlacklistSer({ pageVO, params }) {
        return request.get(`${apis.GET_BLACKLIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 黑名单清单根据ID查询
    getBlacklistByIdSer(params) {
        return request.post(apis.GET_BLACKLIST_BY_ID, params)
    },
    // 黑名单清单创建
    createBlacklistSer(params) {
        return request.post(apis.CREATE_BLACKLIST, params)
    },
    // 黑名单清单更新
    updateBlacklistSer(params) {
        return request.post(apis.UPDATE_BLACKLIST, params)
    },
    // 黑名单清单删除
    deleteBlacklistSer(params) {
        return request.post(apis.DELETE_BLACKLIST, params)
    },
    // 黑名单清单导出
    exportBlacklistSer(params) {
        return request.get(apis.EXPORT_BLACKLIST, { params });
    },
    // 黑名单注册列表
    getBlacklistRegisterSer({ pageVO, params }) {
        return request.get(`${apis.GET_BLACKLIST_REGISTER}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    // 导出黑名单注册
    exportBlacklistRegisterSer(params) {
        return request.get(apis.EXPORT_BLACKLIST_REGISTER, { params });
    },
    // 审批签到统计
    signApprovedStatisticSer(params) {
        return request.post(apis.SIGN_APPROVED_STATISTIC, params)
    },
    // 审批签到统计导出
    signApprovedStatisticExportSer(params) {
        return request.get(apis.SIGN_APPROVED_STATISTIC_EXPORT, { params });
    }
}
